import React, { FC, useState } from "react";
import {
  Row,
  Col,
  Card,
  Button,
  Stack,
  Badge,
  Spinner,
  CardBody,
} from "react-bootstrap";
import {
  getDescriptionColor,
  getTitleColor,
  removeTags,
} from "../../../utils/Constants";
import { FaCheck, FaCopy } from "react-icons/fa";
import { Carousel } from "react-bootstrap";
import "../../../styles.css";
import { getMetaTagsRewrite } from "../../../services/getAiResponse";
import { MetaTagsFormData, MetaTagsResult, UrlKeywords } from "./types";
import { ToolsState, useToolsStore } from "../../../store/useToolsStore";
type Props = {
  formData: MetaTagsFormData | undefined;
};
export const MetaResult: FC<Props> = ({ formData }) => {
  const [copied, setCopied] = useState<number[]>([]);
  const [rewriteSelected, setRewriteSelected] = useState<any>();
  const { setResult, result } = useToolsStore<ToolsState>((state) => state);

  const [showLoader, setShowLoader] = useState<Record<number, boolean>>({});

  const handleCopy = (index: number, index1: number) => {
    const copiedData =
      result?.[index].result[index1] +
      "\n" +
      result?.[index]?.websiteUrl +
      "\n" +
      result?.[index]?.result[index1].description;
    navigator.clipboard
      .writeText(copiedData)
      .then(() => {
        setCopied([...copied, index, index1]);
      })
      .catch((err) => {
        console.error("Failed to copy text:", err);
      });
  };

  const handleRewrite = async (data: MetaTagsResult, index: number) => {
    // setShowLoader(true)
    setShowLoader((prev: any) => ({
      ...prev,
      [index]: true,
    }));

    const response = await getMetaTagsRewrite(data);
    if (response) {
      setShowLoader((prev: any) => ({
        ...prev,
        [index]: false,
      }));
      //updateResult(JSON.parse(response), index);

      const res = JSON.parse(
        response.replaceAll("```json", "").replaceAll("```", "")
      );

      let rsArray = [...result];

      rsArray[index] = res[0];

      setResult(rsArray);

      setRewriteSelected(
        JSON.parse(response.replaceAll("```json", "").replaceAll("```", ""))
      );
    } else {
      setShowLoader((prev: any) => ({
        ...prev,
        [index]: false,
      }));
    }
  };
  // console.log(result, "result-------");

  return (
    <>
      <Row style={{ paddingTop: "10px" }}>
        <Col>
          {result?.map((res, index) => (
            <>
              <Card
                style={{
                  padding: "1rem",
                  marginBottom: "1rem",
                }}
              >
                <Row style={{ minHeight: "" }}>
                  <Col lg={4} style={{ margin: "auto" }}>
                    <Card
                      style={{
                        marginBottom: "5px",
                        minHeight: "150px",
                        padding: "10px",
                      }}
                    >
                      <Row>
                        <Col style={{ color: "#a69a9a", fontSize: 12 }}>
                          URL
                        </Col>
                      </Row>
                      <Row>
                        <Col>{res.websiteUrl}</Col>
                      </Row>
                      <Row>
                        <Col
                          style={{
                            color: "#a69a9a",
                            fontSize: 12,
                            marginTop: "10px",
                          }}
                        >
                          Keyword(s)
                        </Col>
                      </Row>
                      <Row>
                        <Col>
                          {res.keywords?.split(",")?.map((keyword) => (
                            <Badge
                              bg="light"
                              text="dark"
                              style={{
                                padding: "8px",
                                //  border: "1px solid #ddd",
                                borderRadius: "1px",
                                marginTop: "5px",
                                marginRight: "5px",
                              }}
                            >
                              {keyword}
                            </Badge>
                          ))}
                        </Col>
                      </Row>
                      <Row></Row>
                    </Card>
                  </Col>

                  <Col lg={1} style={{ margin: "auto", textAlign: "center" }}>
                    {showLoader[index] && (
                      <Spinner
                        animation="border"
                        role="status"
                        className="spinner"
                      >
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    )}
                    {!showLoader[index] && (
                      <Button
                        size="sm"
                        key={index}
                        variant="primary"
                        onClick={() => {
                          handleRewrite(res, index);
                        }}
                      >
                        Rewrite
                      </Button>
                    )}
                  </Col>
                  <Col style={{ margin: "auto" }}>
                    <Carousel
                      style={{ minHeight: "150px" }}
                      interval={null}
                      controls={false}
                      indicators={true}
                    >
                      {res.result?.map((data, index1: number) => (
                        <Carousel.Item
                          key={index1}
                          style={{ marginTop: "5px" }}
                        >
                          <div
                            style={{
                              wordWrap: "break-word",
                              overflowWrap: "break-word",
                              width: "100%",
                              // padding: "20px",
                            }}
                          >
                            <Card
                              style={{ boxShadow: "none" }}
                              className="carouselCard"
                            >
                              <CardBody className="carouselCardBody">
                                <Row>
                                  <Col lg={1}>
                                    <Badge
                                      bg={getTitleColor(data.title.length)}
                                      style={{
                                        minWidth: "40px",

                                        //  border: "1px solid #ddd",
                                        borderRadius: "5px",
                                      }}
                                    >
                                      {data.title.length}
                                    </Badge>
                                  </Col>
                                  <Col>
                                    <h3 style={{ fontSize: "16px" }}>
                                      {removeTags(data.title)}
                                    </h3>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={1}></Col>
                                  <Col
                                    style={{
                                      marginBottom: ".5rem",
                                      fontStyle: "italic",
                                      color: "success",
                                    }}
                                  >
                                    {removeTags(data.url)}
                                  </Col>
                                </Row>
                                <Row>
                                  <Col lg={1}>
                                    <Badge
                                      style={{
                                        minWidth: "40px",

                                        //  border: "1px solid #ddd",
                                        borderRadius: "5px",
                                      }}
                                      bg={getDescriptionColor(
                                        data.description.length
                                      )}
                                    >
                                      {data.description.length}
                                    </Badge>
                                  </Col>
                                  <Col>
                                    <p>{removeTags(data.description)}</p>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          </div>
                        </Carousel.Item>
                      ))}
                    </Carousel>
                  </Col>
                </Row>
              </Card>
            </>
          ))}
        </Col>
      </Row>
    </>
  );
};
